<div class="container my-2">
  <div class="row easie-form">
    <!-- IN CHARGE USERS-->
    <div class="col-12 mx-auto">
      <p class="easie-form-label mb-0">Teacher in-charge</p>
      <div class="input-group" *ngIf="canUpdate">
        <ion-select [(ngModel)]="pageSpecificFormObject.inchargeUserIds"  multiple="true" interface="popover" class="form-control-selectbox" 
          name="pageSpecificFormObject.inchargeUser" placeholder="Select" [disabled]="!canUpdate" (ionChange)="inchargeUsersChanged($event)">
         <ion-select-option *ngFor="let staff of staffList" value="{{staff.id}}">
           {{staff.lastName}} {{staff.firstName}}
         </ion-select-option>
        </ion-select>
      </div>
      <span *ngIf="staffList.length === 0" class="text-danger"><p><small>No option available for selection!</small></p></span>
    </div>

    <div class="col-12 mx-auto separator-light select-pills"  *ngIf="!canUpdate">
      <div class="row pt-1">
        <div class="col-1"></div>
        <div class="col-11">
          <div class="mb-1">
            <div *ngFor="let staff of staffList">
              <div *ngIf="pageSpecificFormObject.inchargeUserIds && pageSpecificFormObject.inchargeUserIds.includes('' + staff.id)"
                  class="d-flex flex-row  align-items-center">
                <i class="fas fa-minus fa-xs"></i> &nbsp; <p class="font-weight-light mb-0">{{staff.lastName}} {{staff.firstName}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- INVOLVED USERS -->
    <div class="col-12 mt-2 mx-auto">
      <p class="easie-form-label mb-0">Teachers involved</p>
      <div class="input-group" *ngIf="canUpdate">
        <ion-select [(ngModel)]="pageSpecificFormObject.involvedUserIds"  multiple="true" interface="popover" class="form-control-selectbox" 
          name="pageSpecificFormObject.involvedUser" placeholder="Select" [disabled]="!canUpdate" (ionChange)="involvedUsersChanged($event)">
        <ion-select-option *ngFor="let staff of staffListInvolded" value="{{staff.id}}">
          {{staff.lastName}} {{staff.firstName}}
        </ion-select-option>
        </ion-select>
      </div>
      <span *ngIf="staffListInvolded.length === 0" class="text-danger"><p><small>No option available for selection!</small></p></span>
    </div>

    <div class="col-12 mx-auto separator-light select-pills"  *ngIf="!canUpdate">
      <div class="row pt-1">
        <div class="col-1"></div>
        <div class="col-11">
          <div class="mb-1">
            <div *ngFor="let staff of staffListInvolded">
              <div *ngIf="pageSpecificFormObject.involvedUserIds && pageSpecificFormObject.involvedUserIds.includes('' + staff.id)"
                  class="d-flex flex-row  align-items-center">
                <i class="fas fa-minus fa-xs"></i> &nbsp; <p class="font-weight-light mb-0">{{staff.lastName}} {{staff.firstName}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
